"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getLanguage = getLanguage;
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vue = _interopRequireDefault(require("vue"));
var _vueI18n = _interopRequireDefault(require("vue-i18n"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _en = _interopRequireDefault(require("ec-light-vue/lib/locale/lang/en"));
var _zhCN = _interopRequireDefault(require("ec-light-vue/lib/locale/lang/zh-CN"));
var _en2 = _interopRequireDefault(require("./common/en"));
var _zh = _interopRequireDefault(require("./common/zh"));
var _zh2 = _interopRequireDefault(require("./userCenter/zh"));
var _en3 = _interopRequireDefault(require("./userCenter/en"));
var _statutoryZh = _interopRequireDefault(require("./statutory/statutory-Zh"));
var _statutoryEn = _interopRequireDefault(require("./statutory/statutory-En"));
var _zh3 = _interopRequireDefault(require("./spareStockingManage/zh"));
var _en4 = _interopRequireDefault(require("./spareStockingManage/en"));
var _zh4 = _interopRequireDefault(require("./statisticalAnalysis/zh"));
var _en5 = _interopRequireDefault(require("./statisticalAnalysis/en"));
var _zh5 = _interopRequireDefault(require("./stockBase/zh"));
var _en6 = _interopRequireDefault(require("./stockBase/en"));
var _examEn = _interopRequireDefault(require("./qualityfile/exam-En"));
var _learnRecordEn = _interopRequireDefault(require("./qualityfile/learnRecord-En"));
var _learnRecordZh = _interopRequireDefault(require("./qualityfile/learnRecord-Zh"));
var _examZh = _interopRequireDefault(require("./qualityfile/exam-Zh"));
var _manualEn = _interopRequireDefault(require("./qualityfile/manual-En"));
var _manualZh = _interopRequireDefault(require("./qualityfile/manual-Zh"));
var _learnAssignEn = _interopRequireDefault(require("./qualityfile/learnAssign-En"));
var _learnAssignZh = _interopRequireDefault(require("./qualityfile/learnAssign-Zh"));
var _circularEn = _interopRequireDefault(require("./qualityfile/circular-En"));
var _circularZh = _interopRequireDefault(require("./qualityfile/circular-Zh"));
var _qualityImplementEn = _interopRequireDefault(require("./qualityfile/qualityImplement-En"));
var _qualityImplementZh = _interopRequireDefault(require("./qualityfile/qualityImplement-Zh"));
var _marineChartEn = _interopRequireDefault(require("./marine/marineChart-En"));
var _marineChartZh = _interopRequireDefault(require("./marine/marineChart-Zh"));
var _en7 = _interopRequireDefault(require("./book/en"));
var _zh6 = _interopRequireDefault(require("./book/zh"));
var _financeZh = _interopRequireDefault(require("./finance/finance-Zh"));
var _financeEn = _interopRequireDefault(require("./finance/finance-En"));
var _otherControlledFileEn = _interopRequireDefault(require("./qualityfile/otherControlledFile-En"));
var _otherControlledFileZh = _interopRequireDefault(require("./qualityfile/otherControlledFile-Zh"));
var _designFormEn = _interopRequireDefault(require("./qualityfile/designForm-En"));
var _designFormZh = _interopRequireDefault(require("./qualityfile/designForm-Zh"));
var _zh7 = _interopRequireDefault(require("./component/zh"));
var _en8 = _interopRequireDefault(require("./component/en"));
var _zh8 = _interopRequireDefault(require("./statisticAnalysis/zh"));
var _en9 = _interopRequireDefault(require("./statisticAnalysis/en"));
var _zh9 = _interopRequireDefault(require("./standardCode/zh"));
var _en10 = _interopRequireDefault(require("./standardCode/en"));
var _zh10 = _interopRequireDefault(require("./budget/zh"));
var _en11 = _interopRequireDefault(require("./budget/en"));
var _zh11 = _interopRequireDefault(require("./accountingCenter/zh"));
var _en12 = _interopRequireDefault(require("./accountingCenter/en"));
var _zh12 = _interopRequireDefault(require("./accountingMonitor/zh"));
var _en13 = _interopRequireDefault(require("./accountingMonitor/en"));
var _organizationZh = _interopRequireDefault(require("./manage/organization-Zh"));
var _organizationEn = _interopRequireDefault(require("./manage/organization-En"));
var _userAndPermissionZh = _interopRequireDefault(require("./manage/userAndPermission-Zh"));
var _userAndPermissionEn = _interopRequireDefault(require("./manage/userAndPermission-En"));
var _vscLogZh = _interopRequireDefault(require("./manage/vscLog-Zh"));
var _vscLogEn = _interopRequireDefault(require("./manage/vscLog-En"));
var _workflowEn = _interopRequireDefault(require("./manage/workflow-En"));
var _workflowZh = _interopRequireDefault(require("./manage/workflow-Zh"));
var _en14 = _interopRequireDefault(require("./chr/en"));
var _zh13 = _interopRequireDefault(require("./chr/zh"));
var _en15 = _interopRequireDefault(require("./ops/en"));
var _zh14 = _interopRequireDefault(require("./ops/zh"));
var _en16 = _interopRequireDefault(require("./com/en"));
var _zh15 = _interopRequireDefault(require("./com/zh"));
var _en17 = _interopRequireDefault(require("./contract/en"));
var _zh16 = _interopRequireDefault(require("./contract/zh"));
var _en18 = _interopRequireDefault(require("./fin/en"));
var _zh17 = _interopRequireDefault(require("./fin/zh"));
var _zh18 = _interopRequireDefault(require("./desktop/zh"));
var _en19 = _interopRequireDefault(require("./desktop/en"));
var _zh19 = _interopRequireDefault(require("./orgnization/zh"));
var _en20 = _interopRequireDefault(require("./orgnization/en"));
var _zh20 = _interopRequireDefault(require("./interestedParties/zh"));
var _en21 = _interopRequireDefault(require("./interestedParties/en"));
var _zh21 = _interopRequireDefault(require("./pedays/zh"));
var _en22 = _interopRequireDefault(require("./pedays/en"));
var _zh22 = _interopRequireDefault(require("./prHolidays/zh"));
var _en23 = _interopRequireDefault(require("./prHolidays/en"));
var _zh23 = _interopRequireDefault(require("./prMinBdDays/zh"));
var _en24 = _interopRequireDefault(require("./prMinBdDays/en"));
var _zh24 = _interopRequireDefault(require("./ispCommon/zh"));
var _en25 = _interopRequireDefault(require("./ispCommon/en"));
var _zh25 = _interopRequireDefault(require("./ins/zh"));
var _en26 = _interopRequireDefault(require("./ins/en"));
var _en27 = _interopRequireDefault(require("./import/blExchangeAppointment/en"));
var _zh26 = _interopRequireDefault(require("./import/blExchangeAppointment/zh"));
var _en28 = _interopRequireDefault(require("./home/en"));
var _zh27 = _interopRequireDefault(require("./home/zh"));
var _zh28 = _interopRequireDefault(require("./helpDocuments/zh"));
var _en29 = _interopRequireDefault(require("./helpDocuments/en"));
var _zh29 = _interopRequireDefault(require("./portContacts/zh"));
var _en30 = _interopRequireDefault(require("./portContacts/en"));
var _zh30 = _interopRequireDefault(require("./dangerCargo/zh"));
var _en31 = _interopRequireDefault(require("./dangerCargo/en"));
var _zh31 = _interopRequireDefault(require("./surchargeAndMiscellaneous/zh"));
var _en32 = _interopRequireDefault(require("./surchargeAndMiscellaneous/en"));
var _zh32 = _interopRequireDefault(require("./equipment/containerInfo/zh"));
var _en33 = _interopRequireDefault(require("./equipment/containerInfo/en"));
var _zh33 = _interopRequireDefault(require("./equipment/demurrageTariffs/zh"));
var _en34 = _interopRequireDefault(require("./equipment/demurrageTariffs/en"));
var _zh34 = _interopRequireDefault(require("./carbonCalculator/zh"));
var _en35 = _interopRequireDefault(require("./carbonCalculator/en"));
var _zh35 = _interopRequireDefault(require("./vgmApply/zh"));
var _en36 = _interopRequireDefault(require("./vgmApply/en"));
var _zh36 = _interopRequireDefault(require("./roleCertificationApplication/zh"));
var _en37 = _interopRequireDefault(require("./roleCertificationApplication/en"));
var _zh37 = _interopRequireDefault(require("./voyagePlan/zh"));
var _en38 = _interopRequireDefault(require("./voyagePlan/en"));
var _zh38 = _interopRequireDefault(require("./release/zh"));
var _en39 = _interopRequireDefault(require("./release/en"));
var _zh39 = _interopRequireDefault(require("./settlementManagement/exportCostSlipUpload/zh"));
var _en40 = _interopRequireDefault(require("./settlementManagement/exportCostSlipUpload/en"));
var _zh40 = _interopRequireDefault(require("./cargoTrack/zh"));
var _en41 = _interopRequireDefault(require("./cargoTrack/en"));
var _zh41 = _interopRequireDefault(require("./delivery/zh"));
var _en42 = _interopRequireDefault(require("./delivery/en"));
var _zh42 = _interopRequireDefault(require("./import/cargoInfo/zh"));
var _en43 = _interopRequireDefault(require("./import/cargoInfo/en"));
var _zh43 = _interopRequireDefault(require("./settlementManagement/importBillUpload/zh"));
var _en44 = _interopRequireDefault(require("./settlementManagement/importBillUpload/en"));
var _zh44 = _interopRequireDefault(require("./equipment/equipmentFee/zh"));
var _en45 = _interopRequireDefault(require("./equipment/equipmentFee/en"));
var _zh45 = _interopRequireDefault(require("./equipment/demurrageCalculation/zh"));
var _en46 = _interopRequireDefault(require("./equipment/demurrageCalculation/en"));
var _zh46 = _interopRequireDefault(require("./vipCargo/zh"));
var _en47 = _interopRequireDefault(require("./vipCargo/en"));
var _zh47 = _interopRequireDefault(require("./cutTime/zh"));
var _en48 = _interopRequireDefault(require("./cutTime/en"));
var _zh48 = _interopRequireDefault(require("./import/appointmentHistory/zh"));
var _en49 = _interopRequireDefault(require("./import/appointmentHistory/en"));
var _zh49 = _interopRequireDefault(require("./vesselInfo/zh"));
var _en50 = _interopRequireDefault(require("./vesselInfo/en"));
var _zh50 = _interopRequireDefault(require("./vesselMovement/zh"));
var _en51 = _interopRequireDefault(require("./vesselMovement/en"));
var _zh51 = _interopRequireDefault(require("./booking/zh"));
var _en52 = _interopRequireDefault(require("./booking/en"));
// element-ui lang
// element-ui lang

//滚装经营

// 业财管理

// 安全管理

// 业务组件

// 统计分析

// 标准化代码

// 预算管理

// 结算中心

// 后台管理

//发布记录
// 工作台

// 船员池

//相关方

// 计薪天数维护

// 节假日维护

//isp公共

//ins模块

//换单预约

//帮助文档

//口岸联系方式

//危险品

//附加费杂费

//箱信息

// 滞期费费率查询

// 滞期费费率查询

// VGM申报

//角色认证申请查

//船期查询

//船舶动态

//出口费用确认及水单上传

//货物跟踪

//换单时间及费用

//进口货物信息

//进口账单及单据上传

//用箱查询

//滞期费计算器

//vip货物跟踪

//Cut Time

//进口换单预约历史

//船舶资料

//船舶动态

_vue.default.use(_vueI18n.default);
_vue.default.use(_vueI18n.default);
var messages = {
  en: (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _en.default), _en28.default), _learnRecordEn.default), _en2.default), _en3.default), _statutoryEn.default), _en4.default), _en5.default), _en6.default), _examEn.default), _manualEn.default), _learnAssignEn.default), _circularEn.default), _qualityImplementEn.default), _marineChartEn.default), _financeEn.default), _otherControlledFileEn.default), _designFormEn.default), _en8.default), _en9.default), _en10.default), _en11.default), _en12.default), _en13.default), _en21.default), _organizationEn.default), _userAndPermissionEn.default), _vscLogEn.default), _workflowEn.default), _en19.default), _en24.default), _en20.default), _en22.default), _en23.default), _en14.default), _en15.default), _en16.default), _en17.default), _en18.default), _en25.default), _en26.default), _en7.default), _en27.default), _en29.default), _en30.default), _en31.default), _en38.default), _en39.default), _en37.default), _en40.default), _en41.default), _en42.default), _en43.default), _en44.default), _en45.default), _en46.default), _en47.default), _en32.default), _en33.default), _en34.default), _en35.default), _en47.default), _en48.default), _en49.default), _en50.default), _en51.default), _en52.default), _en36.default),
  zh: (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _zhCN.default), _zh27.default), _learnRecordZh.default), _zh.default), _zh2.default), _statutoryZh.default), _zh3.default), _zh4.default), _zh5.default), _manualZh.default), _learnAssignZh.default), _circularZh.default), _qualityImplementZh.default), _examZh.default), _marineChartZh.default), _financeZh.default), _otherControlledFileZh.default), _designFormZh.default), _zh7.default), _zh8.default), _zh9.default), _zh10.default), _zh11.default), _zh12.default), _zh20.default), _organizationZh.default), _userAndPermissionZh.default), _vscLogZh.default), _workflowZh.default), _zh18.default), _zh23.default), _zh19.default), _zh21.default), _zh22.default), _zh13.default), _zh14.default), _zh15.default), _zh16.default), _zh17.default), _zh24.default), _zh25.default), _zh6.default), _zh26.default), _zh28.default), _zh29.default), _zh30.default), _zh37.default), _zh38.default), _zh36.default), _zh39.default), _zh40.default), _zh41.default), _zh42.default), _zh43.default), _zh44.default), _zh45.default), _zh46.default), _zh31.default), _zh32.default), _zh33.default), _zh34.default), _zh46.default), _zh47.default), _zh48.default), _zh49.default), _zh50.default), _zh51.default), _zh35.default)
};
function getLanguage() {
  var chooseLanguage = _jsCookie.default.get('locale');
  if (chooseLanguage) {
    return chooseLanguage.split('-')[0];
  } else {
    _jsCookie.default.set('locale', 'en-US', {
      expires: 7
    });
    return 'en';
  }

  // // if has not choose language
  // const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  // const locales = Object.keys(messages)
  // console.log('国际化==',locales)
  // for (const locale of locales) {
  //   if (language.indexOf(locale) > -1) {
  //     // Cookies.set('locale', locale === 'zh' ? 'zh-CN' : 'en-US')
  //     // return locale
  //     Cookies.set('locale','en-US')//默认设置成英文
  //     return 'en'
  //   }
  // }
  // Cookies.set('locale', 'en-US')
  // return 'en'
}
var i18n = new _vueI18n.default({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages: messages
});
var _default = exports.default = i18n;